import { CustomerState, GlobalState } from '@/types/state'
import * as actionTypes from '@/store/action-types'

import axios from '@/plugins/axios'
import Customer, { CustomerListResponse } from '@/model/customer/Customer'

const state: CustomerState = {}

const getters = {}

const mutations = {}

const actions = {
  async [actionTypes.CUSTOMER_FETCH_CUSTOMER_LIST] ({ rootState }: { rootState: GlobalState }): Promise<Customer[]> {
    const tenantCode: string = rootState.auth.currentUser!.tenant.code

    const response = await axios.get(`/api/${tenantCode}/customer`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })

    return Customer.createFromResponse(response.data as CustomerListResponse)
  },
}

const customerModule = {
  state,
  getters,
  mutations,
  actions
}

export default customerModule
